import { userConstants } from '../_constants';
import { userService } from '../_services';

export const userActions = {
    register
};

function register(name, email, message, token) {
    return dispatch => {
        dispatch(request({ name, email, message }));

        return userService.register(name, email, message, token)
            .then(
                response => {
                    if(response.status === 'not ok'){
                        dispatch(failure(response.details))
                        return Promise.reject(response.details);
                    } else {
                        dispatch(success());
                        return Promise.resolve();
                    }
                }
            );
    };

    function request(user) { return { type: userConstants.REGISTER_REQUEST, user } }
    function success(user) { return { type: userConstants.REGISTER_SUCCESS, user } }
    function failure(error) { return { type: userConstants.REGISTER_FAILURE, payload: error } }
}
